import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colorPropValue'
})
export class ColorPropValuePipe implements PipeTransform {

    transform(active: any, prop: string): string {
        const colorHex = active[prop].substr(1);

        const r = parseInt(colorHex.substr(0, 2), 16);
        const g = parseInt(colorHex.substr(2, 2), 16);
        const b = parseInt(colorHex.substr(4, 2), 16);

        let propAlpha;
        if (prop === 'mainColor' || prop === 'color') {
            propAlpha = 'alpha';
        } else if (/Color$/.test(prop)) {
            const _propAlpha = prop.substr(0, prop.length - 5) + 'Alpha';
            if (active.hasOwnProperty(_propAlpha)) {
                propAlpha = _propAlpha;
            }
        }

        let color;
        const a = active[propAlpha];
        if (isFinite(a)) {
            color = `rgba(${ r },${ g },${ b },${ a })`;
        } else {
            const _r = r.toString(16);
            const _g = g.toString(16);
            const _b = b.toString(16);

            color = `#${ (_r.length === 1 ? `0` : '') + _r }${ (_g.length === 1 ? `0` : '') + _g }${ (_b.length === 1 ? `0` : '') + _b }`;
        }

        return color;
    }

}
